export default "__VITE_ASSET__DAc7Ddsh__"